
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

const swiper = new Swiper('.swiper', {
  modules: [Navigation, Pagination, Autoplay, EffectFade],
  
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  watchSlidesProgress: true,
  
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  
  speed: 800, 
  autoplay: false, 
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  
  pagination: {
    el: '.swiper-pagination',
    clickable: false,
  },
  
  on: {
    init: function() {
      const slideCount = this.slides ? this.slides.length : 0;
      
      let isMouseOnStopElement = false;
      let autoplayTimer = null;
      
      const startAutoplay = () => {
        if (autoplayTimer) {
          clearTimeout(autoplayTimer);
          autoplayTimer = null;
        }
        
        const currentSlideCount = this.slides ? this.slides.length : 0;
        
        if (!isMouseOnStopElement && currentSlideCount > 1) {
          autoplayTimer = setTimeout(() => {
            this.slideNext();
            startAutoplay(); 
          }, 4000);
        }
      };
      
      const stopAutoplay = () => {
        if (autoplayTimer) {
          clearTimeout(autoplayTimer);
          autoplayTimer = null;
        }
      };
      
      const setupStopElements = () => {
        const stopElements = document.querySelectorAll('[data-label="stop"]');
        
        stopElements.forEach(element => {
          element.addEventListener('mouseenter', (e) => {
            isMouseOnStopElement = true;
            stopAutoplay();
          });
          
          element.addEventListener('mouseleave', (e) => {
            isMouseOnStopElement = false;
            startAutoplay();
          });
        });
      };
      
      setupStopElements();
      
      const controller = document.querySelector('.swiper-button__controller');
      if (controller) {
        controller.addEventListener('mouseenter', (e) => {
        });
        
        controller.addEventListener('mouseleave', (e) => {
        });
      }
      
      if (slideCount <= 1) {
        this.loopDestroy();
        
        if (this.autoplay) {
          this.autoplay.stop();
        }
        
        const nextButton = document.querySelector('.swiper-button-next');
        const prevButton = document.querySelector('.swiper-button-prev');
        if (nextButton) nextButton.style.display = 'none';
        if (prevButton) prevButton.style.display = 'none';
        
        const pagination = document.querySelector('.swiper-pagination');
        if (pagination) pagination.style.display = 'none';
        
        const controller = document.querySelector('.swiper-button__controller');
        if (controller) controller.style.display = 'none';
        
      } else {
        const nextButton = document.querySelector('.swiper-button-next');
        const prevButton = document.querySelector('.swiper-button-prev');
        if (nextButton) {
          nextButton.style.display = '';
          nextButton.style.visibility = 'visible';
        }
        if (prevButton) {
          prevButton.style.display = '';
          prevButton.style.visibility = 'visible';
        }
        
        const pagination = document.querySelector('.swiper-pagination');
        if (pagination) pagination.style.display = '';
        
        const controller = document.querySelector('.swiper-button__controller');
        if (controller) controller.style.display = '';
        
        setTimeout(() => {
          const stopElements = document.querySelectorAll('[data-label="stop"]:hover');
          
          if (stopElements.length > 0) {
            isMouseOnStopElement = true;
          } else {
            isMouseOnStopElement = false;
            startAutoplay();
          }
        }, 200);
      }
      
      this.slides.forEach((slide, index) => {
        const dt = slide.querySelector('.top-hero__head');
        const dd = slide.querySelector('.top-hero__body');
        
        if (index === this.activeIndex) {
          if (dt) {
            dt.style.opacity = '0';
            dt.style.transform = 'translateY(4rem) scale(0.95) rotate(-4deg)';
            setTimeout(() => {
              dt.style.transition = 'transform 0.6s ease-out, opacity 0.4s ease-out';
              dt.style.opacity = '1';
              dt.style.transform = 'translateY(0) scale(1) rotate(0deg)';
            }, 300);
          }
          
          if (dd) {
            dd.style.opacity = '0';
            dd.style.transform = 'translateY(4rem) scale(0.95) rotate(-4deg)';
            setTimeout(() => {
              dd.style.transition = 'transform 0.6s ease-out, opacity 0.4s ease-out';
              dd.style.opacity = '1';
              dd.style.transform = 'translateY(0) scale(1) rotate(0deg)';
            }, 500);
          }
        } else {
          if (dt) {
            dt.style.opacity = '0';
            dt.style.transform = 'translateY(4rem) scale(0.95) rotate(-4deg)';
            dt.style.transition = '';
          }
          if (dd) {
            dd.style.opacity = '0';
            dd.style.transform = 'translateY(4rem) scale(0.95) rotate(-4deg)';
            dd.style.transition = '';
          }
        }
      });
    },
    
    slideChangeTransitionStart: function () {
      if (this.slides.length <= 1) return;
      
      const nextSlide = this.slides[this.activeIndex];
      const nextDt = nextSlide?.querySelector('.top-hero__head');
      const nextDd = nextSlide?.querySelector('.top-hero__body');
      
      if (nextDt) {
        nextDt.style.transition = 'none';
        nextDt.style.opacity = '0';
        nextDt.style.transform = 'translateY(4rem) scale(0.95) rotate(-4deg)';
      }
      if (nextDd) {
        nextDd.style.transition = 'none';
        nextDd.style.opacity = '0';
        nextDd.style.transform = 'translateY(4rem) scale(0.95) rotate(-4deg)';
      }
      
      if (this.previousIndex !== undefined) {
        const prevSlide = this.slides[this.previousIndex];
        const prevDt = prevSlide?.querySelector('.top-hero__head');
        const prevDd = prevSlide?.querySelector('.top-hero__body');
        
        if (prevDt) {
          prevDt.style.transition = 'transform 0.4s ease-in-out, opacity 0.3s ease-out 0.1s';
          prevDt.style.transform = 'translateY(-6rem) scale(0.95) rotate(2deg)';
          prevDt.style.opacity = '0';
        }
        if (prevDd) {
          prevDd.style.transition = 'transform 0.4s ease-in-out, opacity 0.3s ease-out 0.15s';
          prevDd.style.transform = 'translateY(-6rem) scale(0.95) rotate(2deg)';
          prevDd.style.opacity = '0';
        }
        
        setTimeout(() => {
          if (nextDt) {
            nextDt.style.transition = 'transform 0.6s ease-out, opacity 0.4s ease-out';
            nextDt.style.opacity = '1';
            nextDt.style.transform = 'translateY(0) scale(1) rotate(0deg)';
          }
          
          if (nextDd) {
            setTimeout(() => {
              nextDd.style.transition = 'transform 0.6s ease-out, opacity 0.4s ease-out';
              nextDd.style.opacity = '1';
              nextDd.style.transform = 'translateY(0) scale(1) rotate(0deg)';
            }, 200);
          }
        }, 500); 
        
      } else {
        setTimeout(() => {
          if (nextDt) {
            nextDt.style.transition = 'transform 0.6s ease-out, opacity 0.4s ease-out';
            nextDt.style.opacity = '1';
            nextDt.style.transform = 'translateY(0) scale(1) rotate(0deg)';
          }
          
          if (nextDd) {
            setTimeout(() => {
              nextDd.style.transition = 'transform 0.6s ease-out, opacity 0.4s ease-out';
              nextDd.style.opacity = '1';
              nextDd.style.transform = 'translateY(0) scale(1) rotate(0deg)';
            }, 200);
          }
        }, 100);
      }
    },
    
    slideChangeTransitionEnd: function () {
      if (this.slides.length <= 1) return;
      const currentSlide = this.slides[this.activeIndex];
      const dt = currentSlide?.querySelector('.top-hero__head');
      const dd = currentSlide?.querySelector('.top-hero__body');
      console.log('Slide transition ended', this.activeIndex);
    }
  }
});